// https://onyxpayments.atlassian.net/wiki/spaces/PION/pages/35160086/Payment+Statuses

export enum UISearchStatusMappingEnum {
  PAYMENT_IN_PROCESS = <any>'paymentInProcess',
  UNPAID = <any>'unpaid',
  PAID = <any>'paid',
  CANCELLED = <any>'cancelled',
  PARTIAL = <any>'partial',
  INVOICED = <any>'invoiced',
  PAID_DIRECT = <any>'paidDirect',
  PAY_SENT = <any>'paySent',
  PENDING = <any>'pending',
  READY_TO_INITIATE = <any>'readyToInitiate',
  REQUEST_REJECTED = <any>'requestRejected',
  REQUESTED = <any>'requested',
  RESENT_REQUEST = <any>'resentRequest',
  FUNDED = <any>'funded',
  PAY_CLEARED = <any>'payCleared',
  CHECK_STOPPED = <any>'checkStopped',
  PAY_REISSUED = <any>'payReissued',
  REJECTED_PAYMENT_REQUESTS = <any>'rejectedPaymentRequests',
  REQUEST_PAYMENTS = <any>'requestPayments',
  MISSING_PAYMENT_ITEMS = <any>'missingPaymentItems',
  MISSING_CONTACT_EMAIL = <any>'MissingEmailContact'
}




// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/ui-search-status-mapping-enum.ts